import type { RadioButtonDesignTokens, RadioButtonTokenSections } from '@primeuix/themes/types/radiobutton';

export const root: RadioButtonTokenSections.Root = {
    width: '1.25rem',
    height: '1.25rem',
    background: '{formField.background}',
    checkedBackground: '{primary.color}',
    checkedHoverBackground: '{primary.hoverColor}',
    disabledBackground: '{formField.disabledBackground}',
    filledBackground: '{formField.filledBackground}',
    borderColor: '{formField.borderColor}',
    hoverBorderColor: '{formField.hoverBorderColor}',
    focusBorderColor: '{formField.focusBorderColor}',
    checkedBorderColor: '{primary.color}',
    checkedHoverBorderColor: '{primary.hoverColor}',
    checkedFocusBorderColor: '{primary.color}',
    checkedDisabledBorderColor: '{formField.borderColor}',
    invalidBorderColor: '{formField.invalidBorderColor}',
    shadow: '{formField.shadow}',
    focusRing: {
        width: '{focusRing.width}',
        style: '{focusRing.style}',
        color: '{focusRing.color}',
        offset: '{focusRing.offset}',
        shadow: '{focusRing.shadow}'
    },
    transitionDuration: '{formField.transitionDuration}',
    sm: {
        width: '1rem',
        height: '1rem'
    },
    lg: {
        width: '1.5rem',
        height: '1.5rem'
    }
};

export const icon: RadioButtonTokenSections.Icon = {
    size: '0.75rem',
    checkedColor: '{primary.contrastColor}',
    checkedHoverColor: '{primary.contrastColor}',
    disabledColor: '{formField.disabledColor}',
    sm: {
        size: '0.5rem'
    },
    lg: {
        size: '1rem'
    }
};

export default {
    root,
    icon
} satisfies RadioButtonDesignTokens;
